import Yaktrek from '../assets/yaktrek.jpg';

const YakTrekSection = () => {
  return (
    <section className="w-full max-w-[1920px] mx-auto relative bg-white">
      <div className="relative w-full">
        <img
          src={Yaktrek}
          alt="Yak Trek in Snow"
          className="w-full h-auto object-cover block"
        />

        <div className="absolute bottom-[8%] sm:bottom-[12%] md:bottom-[15%] lg:bottom-[18%] xl:bottom-[230px]
                        left-0 w-full flex flex-col items-center justify-end px-4 text-center">
          <p
            className="text-[18px] sm:text-[24px] md:text-[28px] lg:text-[32px] xl:text-[36px]
                       font-normal leading-none tracking-[0] text-center drop-shadow-sm"
            style={{ fontFamily: "'Githera Regular', sans-serif" }}
          >
            Gifted by nature, Created by Bodios
          </p>
        </div>
      </div>
    </section>
  );
};

export default YakTrekSection;